const Actions = {
    ADD_SELECTOR: 'ADD_SELECTOR',
    REMOVE_SELECTOR: 'REMOVE_SELECTOR',
    ADD_UPDATER: 'ADD_UPDATER',
    FIELD_VALUE_CHANGED: 'FIELD_VALUE_CHANGED',
    REMOVE_UPDATER: 'REMOVE_UPDATER',
    CANCEL_REQUEST: 'CANCEL_REQUEST',
    SAVE: 'SAVE',
    CLEAR: 'CLEAR',
    CLOSE_MODAL: 'CLOSE_MODAL'
};

export default Actions;